const routes = [
    {
        path: '/business',
        component: require('../components/bills/landing').default,
    },
    {
        path: '/business/landing',
        component: require('../components/bills/landing').default,
    },
    {
        path: '/business/corporate-landing',
        component: require('../components/bills/corporate-landing').default,
    },
    {
        path: '/business/book-demo',
        component: require('../components/bills/book-demo.vue').default,
    },
    {
        path: '/business/sign-up',
        component: require('../components/bills/sign-up.vue').default,
    },
    {
        path: '/business/become-biller',
        component: require('../components/corporate/billers/onboarding/Biller.vue').default,
    },
    {
        path: '/business/create-event',
        component: require('../components/corporate/setup/Event.vue').default,
    },
    {
        path: '/business',
        component: require('../app/corporate/views/dashboard.layout.vue').default,
        meta: {
            requiresCorporateAuth: true
        },

        children: [
            {
                path: '/business/transact',
                component: require('../app/corporate/views/transaction.layout.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'input-transactions'
                },
                children: [
                    {
                        path: '',
                        component: require('../components/bills/business/init').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'input-transactions'
                        },
                    },
                    {
                        path: 'excel',
                        component: require('../components/bills/business/init-excel').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'input-transactions'
                        },
                    },
                    {
                        path: 'form',
                        component: require('../app/corporate/views/transaction.init.form.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'input-transactions'
                        },
                    },
                    {
                        path: "form/:account_name/:group_name?/:account_type/:account_number/:contact_info?",
                        component: require('../app/corporate/views/transaction.init.form.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'input-transactions'
                        },
                    },
                    {
                        path: 'history',
                        component: require('../components/bills/business/init-history').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'input-transactions'
                        },
                    },
                    {
                        path: '/business/create',
                        component: require('../app/corporate/views/transaction.init.form.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'input-transactions'
                        },
                    },
                ]

            },
            {
                path: '/business/access-denied',
                component: require('../components/corporate/components/AccessDenied.vue').default,
            },
            {
                path: '/business/dashboard',
                component: require('../app/corporate/views/dashboard.vue').default,
            },
            {
                path: '/business/transactions',
                component: require('../components/corporate/transactions/Index').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'view-reports'
                },
            },
            {
                path: '/business/batches',
                component: require('../components/corporate/batch/Index').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'view-reports'
                }
            },
            {
                path: '/business/wallets',
                component: require('../components/corporate/wallets/Index').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'view-statements'
                }
            },
            {
                path: '/business/wallets/deposit',
                component: require('../components/corporate/wallets/deposit/init.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'fund-wallets'
                }
            },
            {
                path: '/business/wallets/payout',
                redirect:'/business/wallets',
                component: require('../components/corporate/wallets/payout/Index.vue').default,
                children: [
                    {
                        path: '/business/wallets/payout/:id/request',
                        component: require('../components/corporate/wallets/payout/partials/Form.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'request-payout'
                        }
                    },
                    {
                        path: '/business/wallets/payout/:id/confirmation',
                        component: require('../components/corporate/wallets/payout/partials/PayoutConfirmation.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'request-payout'
                        }
                    },
                ]
            },
            {
                path: '/business/wallets/deposit/ecocash',
                component: require('../components/corporate/wallets/deposit/ecocash.vue').default,
            },

            {
                path: '/business/wallets/deposit/stripe',
                component: require('../components/corporate/wallets/deposit/stripe.vue').default,
            },
            {
                path: 'ecocash',
                component: require('../components/bills/business/ecocash').default,
            },
            {
                path: 'stripe',
                component: require('../components/bills/business/stripe').default,
            },
            {
                path: 'check',
                component: require('../components/bills/business/check').default,
            },

            {
                path: '/business/wallets/deposit/view',
                component: require('../components/corporate/wallets/deposit/view.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'fund-wallets'
                }
            },
           {
                path: '/business/wallet',
                component: require('../components/corporate/wallets/View').default,
                children: [
                    {
                        path: '/business/wallet/:id/view',
                        component: require('../components/corporate/wallets/statements/Wallet.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'view-statements'
                        }
                    },
                    {
                        path: '/business/wallet/:id/payouts',
                        component: require('../components/corporate/wallets/statements/Payout.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'view-statements'
                        }
                    },
                ]
            },
            {
                path: '/business/tickets',
                component: require('../components/corporate/users/Index').default,
            },

            {
                path: '/business/users',
                component: require('../components/corporate/users/Index').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-users'
                },
            },
            {
                path: '/business/profile',
                component: require('../components/corporate/profile/Open').default,
                children: [
                    {
                        path: '/business/profile',
                        component: require('../components/corporate/profile/View').default,
                    },
                    {
                        path: '/business/profile/edit',
                        component: require('../components/corporate/profile/Edit').default,
                    },
                    {
                        path: '/business/profile/password',
                        component: require('../components/corporate/profile/Password').default,
                    },
                ]
            },
            {
                path: '/business/stored-accounts',
                component: require('../components/corporate/stored-accounts/Index.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-stored-accounts'
                }
            },
            {
                path: '/business/stored-accounts/add',
                component: require('../components/corporate/stored-accounts/Create.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-stored-accounts'
                }
            },
            {
                path: '/business/stored-accounts/create-batch',
                component: require('../components/corporate/stored-accounts/BatchCreate.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-stored-accounts'
                }
            },
            {
                path: '/business/stored-accounts/:id',
                component: require('../components/corporate/stored-accounts/Open.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-stored-accounts'
                },
                children: [
                    {
                        path: 'edit',
                        component: require('../components/corporate/stored-accounts/Edit.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-stored-accounts'
                        }
                    }
                ]
            },
            {
                path: '/business/stored-accounts/:id/group',
                component: require('../components/corporate/stored-accounts/Batches.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-stored-accounts'
                }
            },
            {
                path: '/business/stored-accounts/:id/batch',
                component: require('../components/corporate/stored-accounts/BatchDetails.vue').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-stored-accounts'
                }
            },
            {
                path: '/business/settings',
                component: require('../components/corporate/settings/Settings').default,
                children: [
                    {
                        path: 'business-details',
                        component: require('../components/corporate/settings/Edit').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-organisation'
                        }
                    },
                    {
                        path: 'biller-settings',
                        component: require('../components/corporate/settings/biller/Index').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-organisation'
                        }
                    },
                    {
                        path: 'banking-details',
                        component: require('../components/corporate/settings/BankingDetails').default,
                    },
                    {
                        path: 'business-documents',
                        component: require('../components/corporate/settings/BusinessDocuments').default,
                    },
                    {
                        path: 'authorized-individuals',
                        component: require('../components/corporate/settings/AuthorizedIndividuals').default,
                    }
                ]
            },
            {
                path: '/business/users/create',
                component: require('../components/corporate/users/create').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-users'
                }
            },
            {
                path: '/business/users/:id/view',
                component: require('../components/corporate/users/Open').default,
                children: [
                    {
                        path: '/business/users/:id/view',
                        component: require('../components/corporate/users/View').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-users'
                        }
                    },
                    {
                        path: '/business/users/:id/edit',
                        component: require('../components/corporate/users/Edit').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-users'
                        }
                    }
                ]
            },

            // Events
            {
                path: '/business/events',
                component: require('../components/corporate/events/Index').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-events'
                }
            },
            {
                path: '/business/events-form',
                component: require('../components/corporate/events/Form.vue').default,
            },
            {
                path: '/business/edit-events/:id',
                component: require('../components/corporate/events/Edit.vue').default,
            },
            {
                path: '/business/Documents',
                component: require('../components/corporate/events/Documents.vue').default,
            },

            {
                path: '/business/events/:id/view',
                component: require('../components/corporate/events/Open').default,
                children: [
                    {
                        path: '',
                        component: require('../components/corporate/events/Summary.vue').default,
                    },
                    {
                        path: '/business/events/:id/report',
                        component: require('../components/corporate/events/Report.vue').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-events'
                        }
                    },
                ]
            },

            // Payments
            {
                path: '/business/payments',
                component: require('../components/corporate/billers/payments/Index').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'manage-billers'
                }
            },
            {
                path: '/business/payments/create',
                component: require('../components/corporate/billers/payments/Create').default,
                meta: {
                    requiresCorporateAuth: true,
                    permission: 'create-billers'
                }
            },
            {
                path: '/business/payments/:id/view',
                component: require('../components/corporate/billers/payments/Open').default,
                children: [
                    {
                        path: '/business/payments/:id/view',
                        component: require('../components/corporate/billers/payments/View').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-billers'
                        }
                    },
                    {
                        path: '/business/payments/:id/profile',
                        component: require('../components/corporate/billers/payments/Profile').default,
                        meta: {
                            requiresCorporateAuth: true,
                            permission: 'manage-billers'
                        }
                    },

                ]
            },
        ]
    },

    {
        path: '/business/view',
        component: () => import('../app/corporate/views/transaction.view.vue'),
        meta: {
            requiresCorporateAuth: true
        },
    },
];

export default routes;
